import { Page } from './page';

export class MenuNode {
  public static readonly TITLE_KEY = 'title';

  public static readonly NAVIGATION = 'Navigation';
  public static readonly FOOTER = 'Footer';

  public name: string;
  public link: string;
  public page: Page;
  public children: MenuNode[];

  constructor() {
    this.children = [];
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/menu-node.ts